<template>
  <div>
      <h1>This is "My Products" module</h1>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>